// Module
var code = `   <div class-js-sltp-numeric="1"
     class-tr-stop-visible={{trStopVisible}}
     style="{{>visibility}}">

        {{#if isVisibleEnableButton}}
        <terceraCheckBoxButton isSL="{{isSL}}"
                            hasError="{{hasError}}"
                            text="{{.isSL?'SL':'TP'}}"
                            checked="{{SLTPChecked}}"
                            tooltip="{{.tooltip}}"
                            focused="{{focused}}"/>
        {{/if}}
        
        <terceraNumeric name="terceraNumeric"
                        tradingNumeric="true"
                        value="{{value}}"
                        minValue="{{minValue}}"
                        maxValue="{{maxValue}}"
                        step="{{step}}"
                        decimalPrecision="{{decimalPrecision}}"
                        enabled="{{SLTPChecked && canEdit}}"
                        Intervals="{{Intervals}}"
                        focused="{{numericFocused}}"
                        hasError="{{hasError}}"
                        errorText="{{errorText}}"
                        customErrorText="{{customErrorText}}"
                        customError={{customError}}
                        validationStateInfo="{{validationStateInfo}}"
                        on-TerceraNumericClicked="terceraNumericInputClick" 
                        enableOnSelect="true"
                        rightAlignedText="{{rightAlignedText}}"
                        rightAlignedTextAdditionalClass="watermark"
                        valueUpDownChangeProcess="{{@this.valueUpDownChangeProcess}}"/>

        {{#if trStopVisible}}
        <terceraButton name="trailingStopBtn"
                    terceraButtonStyle="js-trStopBtn"
                    SVG="true"
                    canCheck="true"
                    checked="{{trStopChecked}}"
                    enabled="{{SLTPChecked}}" />
        {{/if}}
    </div>`;
// Exports
export default code;